<ng-container *ngIf="canView">

    <mat-expansion-panel *ngIf="!isValidating" [expanded]="true" style="margin: 10px 0px;">

        <mat-expansion-panel-header>
            <mat-panel-title>
                Actualización de 2do. Venc. de Movimiento
            </mat-panel-title>
            <mat-panel-description>
            </mat-panel-description>
        </mat-expansion-panel-header>

        <form [formGroup]="formGroup">

            <div fxLayout="row stretch" fxLayout.xs="column">

                <div fxFlex=25 fxFlex.xs=100 class="flex-item">

                    <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label class="text-style">Fecha Inicial de Control</mat-label>
                        <input class="text-style" matInput [matDatepicker]="fechaInicialControlPicker" formControlName="FechaInicialControl"  (click)="fechaInicialControlPicker.open()">
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaInicialControlPicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #fechaInicialControlPicker></mat-datepicker>
                    </mat-form-field>

                </div>
                <div fxFlex=25 fxFlex.xs=100 class="flex-item">

                    <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label class="text-style">Fecha Final de Control</mat-label>
                        <input class="text-style" matInput [matDatepicker]="fechaFinalControlPicker" formControlName="FechaFinalControl"  (click)="fechaFinalControlPicker.open()">
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaFinalControlPicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #fechaFinalControlPicker></mat-datepicker>
                    </mat-form-field>

                </div>

                <div fxFlex=25 fxFlex.xs=100 class="flex-item">

                    <mat-form-field appearance="outline" style="width: 100%">
                        <mat-label class="text-style">Fecha Vencimiento de Control</mat-label>
                        <input class="text-style" matInput [matDatepicker]="fechaVencimientoControlPicker" formControlName="FechaVencimientoControl"  (click)="fechaVencimientoControlPicker.open()">
                        <mat-datepicker-toggle style="display:inline-block;" matSuffix [for]="fechaVencimientoControlPicker">
                        </mat-datepicker-toggle>
                        <mat-datepicker #fechaVencimientoControlPicker></mat-datepicker>
                    </mat-form-field>

                </div>
                <div fxFlex=25 fxFlex.xs=100 class="flex-item">
                    <mat-form-field appearance="outline" style="width: 100%">
                      <mat-label *ngIf="!isComunidadSearching">{{'Comunidad' | translate}}</mat-label>
                      <mat-label *ngIf="isComunidadSearching">Cargando...</mat-label>
                      <mat-select formControlName="ComunidadId">
                        <mat-option>Todas</mat-option>
                        <mat-option *ngFor="let s of comunidadList" [value]="s.Id">{{s.Nombre}}</mat-option>
                      </mat-select>
                    </mat-form-field>
                </div>

            </div>

        </form>

        <div fxLayout="row stretch" fxLayout.xs="column" style="margin-top: 10px;">
            <button mat-raised-button (click)="runJob()" [disabled]="isRunning" color="primary" class="zb-button">{{isRunning ? 'Ejecutando...' : 'Ejecutar'}}</button>
        </div>

    </mat-expansion-panel>

</ng-container>
